import { render } from "./Sv021.vue?vue&type=template&id=27484dfa&scoped=true"
import script from "./Sv021.vue?vue&type=script&lang=js"
export * from "./Sv021.vue?vue&type=script&lang=js"

import "./Sv021.vue?vue&type=style&index=0&id=27484dfa&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27484dfa"]])

export default __exports__